<template>
  <header id="app-header">
      <!-- <div class="bpoint"></div> -->
     <div class="col md-3" id="logo-container">
         <div class="logo" >
           <!-- <a v-bind:href="maContent.ma1_4">
           <img v-bind:src="maContent.ma1_3" alt="">
           </a> -->
          
            <router-link :to="{ path: '/'}" >
                  <img src="@/assets/images/company-logo.png" alt="">
            </router-link>
            
          
         </div>
     </div>

    <div class="col md-9" id="nav-container">
        <div class="nav-links-account">
          <ul>
            <li v-if="userData" class="account-li">
                <router-link 
                    active-class="uk-active" 
                    :to="{ path: '/dashboard'}" 
                    exact
                >
                  <div class="header__profile"></div>
                  <div class="header__welcome-wrap">
                    <div class="header__welcome">Welcome back,</div>
                    <div class="header__user">{{userData.firstName}}</div>
                  </div>
                </router-link>
            </li>
            <!-- <li v-if="userData">
              <button @click="logout">logout</button>
            </li> -->
            <li v-if="!userData">
              
                <router-link 
                      
                      active-class="uk-active" 
                      :to="{ path: '/login-or-register'}" 
                      exact
                  >
                  <button class="primary login">Login</button>
                  </router-link>
            </li>
          </ul>
        </div>
        <ul class="nav-links-normal">
              <!-- <li class="">
                  <router-link 
                      active-class="uk-active" 
                      :to="{ path: '/faqs'}" 
                      exact
                  >
                  FAQs
                  </router-link>
              </li> -->
             <div class="header-info header__phone-h"><h4>{{maContent.ma1_5}}&nbsp;</h4></div>
             <div class="header-info header__phone"><h4>{{maContent.ma1_2}}</h4></div>
             <a v-bind:href="'mailto:' + maContent.ma1_6">
                  <div class="header-info header__email"><h4>&nbsp;</h4>
                  </div>
              </a>              
             <a v-bind:href="maContent.ma1_2_1">
               <div class="header__phone-mob"></div>
              </a>
           <!-- <div class="header-info header__faq"> <a v-bind:href="maContent.ma1_1_2">{{maContent.ma1_1_1}}</a></div>-->

        </ul>
    </div>
    <div class="clearfix"></div>

  </header>
</template>

<script>


export default {

  computed : {
    // designData(){
    //     return this.$store.getters.getDesignData;
    //   },
    maContent(){
      return this.$store.getters.getBuildData;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userData(){
      return this.$store.getters.getUserInfo;
    }
  },
  methods : {
  
    logout(){
      $store.dispatch('userLogout');
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/common/Header.vue